import { motion } from "framer-motion";
import {
  FiCloud,
  FiMonitor,
  FiSmartphone,
  FiLock,
  FiDatabase,
  FiTrendingUp,
  FiShare2,
  FiShield,
  FiCode,
  FiUsers,
  FiTool,
} from "react-icons/fi";

const services = [
  {
    title: "IT Consultancy",
    icon: <FiUsers />,
    description:
      "Expert IT consulting to optimize your digital transformation and growth strategy.",
  },
  {
    title: "Custom Software Development",
    icon: <FiTool />,
    description:
      "Tailored software solutions built for performance, scalability, and innovation.",
  },
  {
    title: "Web Development",
    icon: <FiMonitor />,
    description:
      "Responsive, high-speed websites that turn visitors into loyal customers.",
  },
  {
    title: "Android Development",
    icon: <FiSmartphone />,
    description:
      "Custom Android apps with sleek UI and seamless user experiences.",
  },
  {
    title: "Cloud Services",
    icon: <FiCloud />,
    description:
      "Scalable and secure cloud infrastructure that grows with your business.",
  },
  {
    title: "Computer Networking",
    icon: <FiShare2 />,
    description:
      "Reliable networking solutions for smooth and secure communication.",
  },
  {
    title: "Data Backup",
    icon: <FiDatabase />,
    description:
      "Secure, automated backup systems for complete data protection.",
  },
  {
    title: "Data Security",
    icon: <FiShield />,
    description:
      "Next-gen cybersecurity solutions to safeguard your business information.",
  },
  {
    title: "Branding",
    icon: <FiTrendingUp />,
    description:
      "Powerful branding that builds trust and makes your business stand out.",
  },
  {
    title: "Advertisement",
    icon: <FiLock />,
    description:
      "Targeted campaigns to expand your brand reach and engagement.",
  },
  {
    title: "Marketing",
    icon: <FiCode />,
    description:
      "Result-driven marketing strategies to increase visibility and revenue.",
  },
  {
  title: "Digital Signage Solution",
  icon: <FiMonitor />, // better suited than FiCode
  description:
    "Engage your audience with dynamic digital displays that deliver real-time content and brand messaging across locations.",
},
];

export default function ServicesPage() {
  return (
    <section className="bg-white py-20 px-6 md:px-12">
      {/* Section Header */}
      <div className="text-center mt-10 mb-16">
        <motion.h2
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-4xl md:text-5xl font-extrabold text-gray-800 mb-4"
        >
          Our <span className="text-orange-500">Services</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-gray-600 text-lg max-w-2xl mx-auto"
        >
          Empowering businesses with cutting-edge technology and innovation.
        </motion.p>
      </div>

      {/* Services Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {services.map((service, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            whileHover={{ scale: 1.05 }}
            className="relative overflow-hidden bg-white rounded-3xl shadow-lg p-8 text-center group cursor-pointer transition-all duration-500"
          >
            {/* Animated Hover Background */}
            <div className="absolute inset-0 bg-gradient-to-t from-gray-300 via-gray-200 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>

            {/* Card Content */}
            <div className="relative z-10 flex flex-col items-center">
              <div className="text-6xl text-orange-500 mb-4 group-hover:scale-110 transition-transform duration-500">
                {service.icon}
              </div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-3 group-hover:text-orange-600 transition-colors duration-500">
                {service.title}
              </h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
